import React, { useEffect, useState } from "react";
import {
  Box,
  VStack,
  Heading,
  Spinner,
  Text,
  Alert,
  AlertIcon,
  useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import { useTranslation } from "react-i18next";


const FeedbackSummary = ({ userId }) => {
  const { t, i18n } = useTranslation();

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEmpty, setIsEmpty] = useState(false); // Add a state to track empty feedback
  const cardBgColor = useColorModeValue("white", "gray.700");

  useEffect(() => {
    const fetchFeedbackSummary = async () => {
      if (!userId) {
        setError(t("feedbacksummary.user_id_required"));
        setLoading(false);
        return;
      }
  
      try {
        setLoading(true);
        const response = await axios.get(
          `${import.meta.env.VITE_API_APP_BACKEND_URL}/getFeedbackSummary`,
          { params: { userId } }
        );
  
        if (response.status === 200) {
          console.log("Feedback Summary:", response.data.averageScores);
          setSummary(response.data.averageScores);
        } else if (response.data?.isEmpty) {
          setIsEmpty(true);
        } else {
          console.error("Error fetching feedback:", response.data.error);
          setError(response.data.error || t("feedbacksummary.generic_error"));
        }
      } catch (err) {
        console.error("Failed to fetch feedback summary:", err);
        setError(t("feedbacksummary.fetch_failed"));
      } finally {
        setLoading(false);
      }
    };
  
    fetchFeedbackSummary();
  }, [userId]);
  

  if (loading) {
    return (
      <Box textAlign="center" py={8}>
        <Spinner size="lg" />
        <Text mt={4}>{t("feedbacksummary.loading_feedback")}</Text>
      </Box>
    );
  }

  if (error) {return;}
/*   if (error) {
    return (
      <Box textAlign="center" py={8}>
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  } */

  if (isEmpty) {
    return (
      <Box textAlign="center" py={8}>
        <Heading size="md" mb={4}>
        {t("feedbacksummary.no_feedback")}
        </Heading>
        <Text>{t("feedbacksummary.no_feedback_desc")}</Text>
      </Box>
    );
  }

  return (
    <Box bg={cardBgColor} p={8} borderRadius="lg" shadow="md">
      <VStack spacing={4}>
      <Heading size="md">{t("feedbacksummary.feedback_summary")}</Heading>
      {summary && (
          <Box>
            {Object.entries(summary).map(([key, value]) => (
              <Text key={key}>
                <strong>{key.replace(/([A-Z])/g, " $1")}</strong>: {value} / 5
              </Text>
            ))}
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default FeedbackSummary;
